import React, { useEffect } from 'react'
import "./main-prescription.scss"
import Medicine from '../../prescription/main-prescription/medicine/medicine'
import { useDispatch, useSelector } from 'react-redux'
import { getTemplateDetails } from '../../../store/slices/templateSlice'
import Complaints from './complaints/complaints'
import LabTest from '../../prescription/main-prescription/labtest/labtest'
import Advice from '../../prescription/main-prescription/advice/advice'
import MasterDataManager from '../../prescription/master-data-manager/master-data-manager'
import DiagnosisTemplate from './diagnosis/diagnosis'

const TemplatePrescription = ({ selectedTemplate, doctorId }) => {
    const dispatch = useDispatch();
    let { templateDetails } = useSelector((state) => state.template);

    useEffect(() => {
        const payload = { templateId: selectedTemplate?._id, doctorId: doctorId }
        dispatch(getTemplateDetails(payload));
    }, [selectedTemplate]);


    return (
        <div className='prescription-full-body' >
            <div className='template-layout'>
                <div className='left-col'>
                    <div className='compliant-section' >
                        <Complaints doctorId={doctorId} templateId={selectedTemplate?._id}></Complaints>
                        <DiagnosisTemplate doctorId={doctorId} templateId={selectedTemplate?._id}></DiagnosisTemplate>
                    </div>
                </div>
                <div className='right-col'>
                    <div className='medicine-section position-relative'>
                        <Medicine templateDetails={templateDetails} doctorId={doctorId} templateId={selectedTemplate?._id}></Medicine>
                    </div>
                    <div className='labTest-advice-section-1'>
                        <div className='lab-test'>
                            <p className='title'>Lab test<MasterDataManager entity="labTest" doctorId={doctorId}></MasterDataManager></p>
                            <div className='sub-section-search'><LabTest doctorId={doctorId} templateId={selectedTemplate?._id}></LabTest></div>

                        </div>
                        <div className='advice-col'>
                            <p className='title position-relative'>Advice<MasterDataManager entity="advice" doctorId={doctorId}></MasterDataManager></p>
                            <div className='sub-section-search'><Advice doctorId={doctorId} templateId={selectedTemplate?._id}></Advice></div>
                            {/* <Advice doctorId={doctorId} templateId={selectedTemplate?._id}></Advice> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TemplatePrescription
